import { InjectionToken } from "@angular/core";
import { StaffBenefitsPort } from "./staff-benefits.port";

export const STAFF_BENEFITS_PORT = new InjectionToken<StaffBenefitsPort>(
  "STAFF_BENEFITS_PORT",
);
